/* GET LEAD_PRICES */
export const GET_LEAD_PRICES = "GET_LEAD_PRICES"
export const GET_LEAD_PRICES_SUCCESS = "GET_LEAD_PRICES_SUCCESS"
export const GET_LEAD_PRICES_ERROR = "GET_LEAD_PRICES_ERROR"
